<template>
  <el-dialog title="资产维护" :visible.sync="show" :before-close="close" center destroy-on-close>
    <el-form ref="form" :rules="rules" :model="info" label-width="22%">
      <el-row>
          <el-col :span="24">
            <el-form-item label="资产编号" prop="assetsNo">
              <el-input placeholder="请输入资产编号" show-word-limit v-model="info.assetsNo" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="资产名称" prop="assetsName">
              <el-input  placeholder="请输入资产名称" show-word-limit v-model="info.assetsName" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="品牌" prop="brand">
              <el-input  placeholder="请输入品牌" show-word-limit v-model="info.brand" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="库存量" prop="inventory" class="formItem">
               <el-input-number v-model="info.inventory" :min="0" placeholder="大于等于0"
                    style="width:100%;" :controls="false"
                    ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input  type="textarea" :rows="5" placeholder="请输入备注" maxlength="200"
                show-word-limit v-model="info.remark" />
            </el-form-item>
          </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="addEventForm()" >提 交</el-button>
      <el-button @click="close">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { compAssetsInfo } from '@/api/assets.js'
import { queryUserInfo } from '@/api/basicInfo'
export default {
  data() {
    return {
      timeValue: [],
      info: {
        assetsNo: '', // 资产编号
        assetsName: '', // 资产名称
        brand: '', // 品牌
        inventory: '', // 库存量
        remark: '', // 库存量
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      carList: [],
      statusOptions: [
        {
          value: '1',
          label: '通过'
        },
        {
          value: '2',
          label: '拒绝'
        },
        {
          value: '3',
          label: '转办'
        },
        {
          value: '4',
          label: '退回上一级'
        },
      ],
      rules: {
        assetsNo: [{ required: true, message: '请输入', trigger: 'change' }],
        assetsName: [{ required: true, message: '请输入', trigger: 'change' }],
        brand: [{ required: true, message: '请输入', trigger: 'change' }],
        inventory: [{ required: true, message: '请输入', trigger: 'blur' }],
        remark: [{ required: true, message: '请输入', trigger: 'blur' }],
      },
      id: '',
      type: '',
      actionType: '',
      show: false,
      userInfoList: [],
      activeName: '',
      auditInfo: {
        auditProcessEntityList: [],
        createTime: '',
        applyUser: '',
        auditPerson: '',
        approvalFlag: false
      }
    }
  },
  mounted() {
    this.queryList()
  },
  methods: {
    handleStatus(creatUser) {
     let userName = JSON.parse(localStorage.getItem('jiadingFangwu_userInfo')).userName
     if (userName === creatUser) {
      this.statusOptions = [
        {
          value: '1',
          label: '通过'
        },
        {
          value: '2',
          label: '拒绝'
        },
        {
          value: '3',
          label: '转办'
        },
      ]
     }
    },
    handleRemark(val) {
      if (val === '1') {
        this.info.remark = '同意'
      } else if (val === '3') {
        this.info.remark = '转办'
      } else {
        this.info.remark = ''
      }
    },
    // 强制更新测试文本信息框的值
    changeMessage() {
      this.$forceUpdate()
    },
    async queryList() {
      let res = await queryUserInfo({
        pageNum: 1,
        pageSize: 9999,
      })
      if (res.code === 0) {
        this.userInfoList = res.result.records
      }
    },
    showDetails(type, id, activeName) {
      this.type = type
      this.show = true
      this.activeName = activeName
      if (id) {
        this.getDetails(id)
      }
    },
    getDetails(id) {
      this.id = id
      compAssetsInfo('query', { id }).then(res => {
        const { code, result: { records } } = res
        if (code !== 0) return
        // this.handleStatus(records.createUser)
        this.info = {
          assetsNo: records[0].assetsNo, // 资产编号
          assetsName: records[0].assetsName, // 资产名称
          brand: records[0].brand, // 品牌
          inventory: records[0].inventory, // 库存量
          remark: records[0].remark, // 库存量
          // eventId: result.eventId,
          // lastUserFlag: result.lastUserFlag,
          // nextAuditUserName: result.nextAuditUserName,
          // auditPersonId: result.auditPersonId,
          // status: result.approvalFlag === true ? '' : result.status,
        }
        // this.timeValue = [result.begin, result.end]
        // this.auditInfo = {
        //   auditProcessEntityList: result.auditProcessEntityList,
        //   createTime: result.createTime,
        //   applyUser: result.applyUser,
        //   auditPerson: result.auditPerson,
        //   approvalFlag: result.approvalFlag
        // }
      })
    },
    close() {
      this.show = false
      this.timeValue = []
      this.info = {
        assetsNo: '', // 资产编号
        assetsName: '', // 资产名称
        brand: '', // 品牌
        inventory: '', // 库存量
        remark: '', // 库存量
      }
      this.id = ''
      this.auditInfo = {
        auditProcessEntityList: [],
        createTime: '',
        applyUser: '',
        auditPerson: '',
        approvalFlag: false
      }
    },
    addEventForm() {
      this.$refs.form.validate(async (vaild) => {
        if (vaild) {
          console.log(this.info);
          let params = {
              ...this.info,
              id: this.id
          }
          const { code, message } = await compAssetsInfo(this.id === '' ? 'addAssetsInfo' : 'updateAssetsInfo', params)
          if (code !== 0) {
            this.$message.error(message)
            return
          }
          this.$message.success('提交成功！')
          this.$emit('addSuccess')
          this.close()
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog {
  min-width: 540px;
  width: 50%;
}
</style>
